module.exports = __webpack_public_path__ + "static/img/icon_app_download.75a55c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_app_download.png
// module id = MdDD
// module chunks = 1